import {
  Button,
  Dropdown,
  DropdownContent,
  DropdownTrigger,
  RiArrowDownSLine,
  RiFocus2Line,
} from '@landler/component-library';
import { BBox2d } from '@turf/helpers/dist/js/lib/geojson';
import { FeatureCollection, Point } from 'geojson';
import { useTranslation } from 'react-i18next';
import { MapRef } from 'react-map-gl';

import { NO_RADIUS, RadiusType } from '@/components/MapOverview/components/MapRadiusContextProvider';
import { ReportingBoundsLayer, ReportingBoundsPicker } from '@/components/MapOverview/components/ReportingBoundsLayer';
import { BackgroundToggle } from '@/components/widgets/o/Map/LayerEditMenu/BackgroundToggle';
import { PlotOverviewToggle } from '@/components/widgets/o/Map/LayerEditMenu/PlotOverviewToggle';
import { isNullish } from '@/utils/booleans';

export const MapSettings = ({
  radius,
  bounds,
  mapRef,
  plotMarkers,
}: {
  radius?: RadiusType | null;
  bounds: BBox2d;
  mapRef: MapRef | null;
  plotMarkers?: FeatureCollection<Point>;
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Dropdown>
        <DropdownTrigger asChild>
          <Button
            variant='contained'
            color='white'
            size='small'
            data-testid='show-radius-dropdown-trigger'
            leftAdornment={<RiFocus2Line />}
            rightAdornment={<RiArrowDownSLine />}
            className='absolute right-6 top-6 group/settings'
          >
            {radius === NO_RADIUS || isNullish(radius) ? (
              <span className='hidden group-hover/settings:block'>{t('navbar.settings')}</span>
            ) : (
              t('shared.projects.map.labels.showRadius', { radius })
            )}
          </Button>
        </DropdownTrigger>
        <DropdownContent className='mt-2 rounded-[20px] flex flex-col gap-6 px-4 py-4'>
          {plotMarkers && <ReportingBoundsPicker bounds={bounds} mapRef={mapRef ?? null} />}
          <BackgroundToggle />
          <PlotOverviewToggle />
        </DropdownContent>
      </Dropdown>
      {plotMarkers && <ReportingBoundsLayer plotMarkers={plotMarkers} />}
    </>
  );
};
